/**
 * Cookie utility functions
 * Provides cookie detection and parsing for client-side auth checks
 */

/**
 * Check if the auth indicator cookie exists (indicating user might be logged in)
 * @returns {boolean} True if auth indicator cookie exists
 * 
 * Note: We check for auth_indicator instead of session because the actual
 * session cookie is httpOnly (for security) and cannot be read by JavaScript.
 * The auth_indicator is a non-httpOnly cookie that simply indicates auth presence.
 */
export const hasSessionCookie = () => {
  if (typeof document === 'undefined') {
    return false; // SSR safety
  }
  
  return document.cookie
    .split(';')
    .some(cookie => cookie.trim().startsWith('auth_indicator='));
};

/**
 * Get a specific cookie value by name
 * @param {string} name - Cookie name
 * @returns {string|null} Cookie value or null if not found
 */
export const getCookie = (name) => {
  if (typeof document === 'undefined') {
    return null; // SSR safety
  }
  
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  
  if (parts.length === 2) {
    return parts.pop().split(';').shift();
  }
  
  return null;
};